import React from 'react';
import { Drawer } from '@mui/material';
import { IconChevronLeft } from '@tabler/icons-react';
import { THINGS_TO_KNOW_TIPS } from './thingsToKnowTips';

interface ThingsToKnowDrawerProps {
  open: boolean;
  onClose: () => void;
}

const ThingsToKnowDrawer: React.FC<ThingsToKnowDrawerProps> = ({
  open,
  onClose,
}) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: '24px 24px 0 0',
            maxHeight: '85vh',
          },
        },
      }}
    >
      <div className="p-6">
        <button
          type="button"
          className="flex items-center gap-2"
          onClick={onClose}
          aria-label="Close things to know"
        >
          <IconChevronLeft size={22} />
          <span className="font-semibold text-neutral-800">Things to know</span>
        </button>
        <ul className="mt-6 flex flex-col gap-4">
          {THINGS_TO_KNOW_TIPS.map(tip => (
            <li key={tip.title}>
              <h3 className="font-semibold text-neutral-800">{tip.title}</h3>
              <p className="text-sm text-neutral-600 mt-1">{tip.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </Drawer>
  );
};

export default ThingsToKnowDrawer;
